import { trigger, style, animate, transition, state } from '@angular/animations';

export const clientFadeAnimation = trigger('fadeAnimation', [
  transition('void => *', [
    style({ opacity: 0 }),
    animate('0.4s')
  ]),
  transition('* => void', [
    animate('0.4s', style({ opacity: 0 }))
  ]),
]);


export const clientFadeOutAnimation = trigger('fadeOutAnimation', [
  state('out',
    style({ opacity: 0, display: 'none' })
  ),
  transition('* => out', [
    animate('0.4s')
  ])
]);